const PUBLIC_PDF_STYLES = [
  { key: 'editorial_minimal', label: 'Editorial Minimal', note: 'Sobrio · arioso', preview: 'minimal' },
  { key: 'magazine_bold', label: 'Magazine Bold', note: 'Forte · dinamico', preview: 'magazine' },
  { key: 'studio_blue', label: 'Studio Blue', note: 'Bold · blu editoriale', preview: 'studio-blue' },
];

const SIGNATURE_STYLE = { key: 'private_signature', label: 'Signature', note: 'Privato · personale', preview: 'signature' };

export function defaultPdfStyle(isAdmin) {
  return isAdmin ? SIGNATURE_STYLE.key : PUBLIC_PDF_STYLES[0].key;
}

function Preview({ variant, large = false }) {
  const frame = large ? 'h-[150px] w-[100px] rounded-md' : 'h-9 w-7 rounded-[2px]';
  const pad = large ? 'p-4' : 'p-1';
  const padWide = large ? 'p-4' : 'p-1.5';
  if (variant === 'magazine') return <div className={`${frame} overflow-hidden bg-[#121110] ${pad}`}><div className={`${large?'mt-5 h-2 w-12':'mt-1 h-1 w-4'} bg-[#B4552A]`} /><div className={`${large?'mt-3 h-8 w-16':'mt-1 h-2 w-5'} bg-[#F2ECE0]`} /><div className={`${large?'mt-3 h-2 w-10':'mt-1 h-1 w-3'} bg-[#C79A3E]`} /></div>;
  if (variant === 'studio-blue') return <div className={`${frame} overflow-hidden bg-[#1F4BFF] ${pad}`}><div className={`${large?'mt-4 h-1.5 w-12':'mt-1 h-[2px] w-4'} bg-white`} /><div className={`${large?'mt-4 h-9 w-16':'mt-1 h-2 w-5'} bg-white`} /><div className={`${large?'mt-2 h-6 w-12':'mt-1 h-1.5 w-4'} bg-white/60`} /><div className={`${large?'mt-4 h-1':'mt-1 h-[2px]'} w-full bg-white/45`} /></div>;
  if (variant === 'signature') return <div className={`${frame} bg-[#1A1714] ${pad}`}><div className={`${large?'h-20':'h-4'} w-full bg-[#4A433B]`} /><div className={`${large?'mt-4 h-1 w-12':'mt-1 h-[2px] w-4'} bg-[#C79A3E]`} /><div className={`${large?'mt-3 h-2 w-16':'mt-1 h-1 w-5'} bg-[#F2ECE0]`} /></div>;
  return <div className={`${frame} bg-[#F7F4EF] ${padWide}`}><div className={`${large?'h-1 w-7':'h-[2px] w-2'} bg-[#B8873A]`} /><div className={`${large?'mt-5 h-8':'mt-1 h-2'} w-full bg-[#1C1A17]`} /><div className={`${large?'mt-4 h-1 w-14':'mt-1 h-[2px] w-4'} bg-[#8A8378]`} /><div className={`${large?'mt-6 h-1':'mt-1 h-[2px]'} w-full bg-[#DFD8CB]`} /></div>;
}

export default function MasterPdfStyleSelector({ value, onChange, isAdmin = false, disabled = false, variant = 'compact' }) {
  const options = isAdmin ? [...PUBLIC_PDF_STYLES, SIGNATURE_STYLE] : PUBLIC_PDF_STYLES;
  const large = variant === 'studio';
  return <div data-testid="master-pdf-template-selector" data-variant={variant}>
    <div className="mb-2 flex items-center justify-between gap-2">
      <p className={`${large?'text-sm':'text-[11px]'} font-semibold text-white`}>Stile PDF</p>
      <span className={`${large?'text-[10px]':'text-[9px]'} text-white/55`}>{value === 'private_signature' ? 'Signature' : '5 pagine'}</span>
    </div>
    <div className={large ? 'grid grid-cols-1 gap-3' : 'grid grid-cols-2 gap-1.5'}>
      {options.map(option => {
        const selected = value === option.key;
        return <button
          key={option.key}
          type="button"
          className={`${large?'min-h-[174px] p-3':'min-h-[58px] px-2 py-2'} flex items-center gap-3 rounded-xl border text-left transition-colors disabled:opacity-50`}
          style={selected ? { borderColor: 'var(--accent-purple)', background: 'rgba(168,85,247,.18)' } : { borderColor: 'var(--border-color)', background: 'transparent' }}
          aria-pressed={selected}
          data-testid={`master-pdf-template-${option.key}`}
          onClick={() => onChange(option.key)}
          disabled={disabled}
        >
          <Preview variant={option.preview} large={large} />
          <span className="min-w-0"><span className={`block ${large?'text-xs':'truncate text-[10px]'} font-semibold text-white`}>{option.label}</span><span className={`${large?'mt-1 text-[10px]':'mt-0.5 text-[8px]'} block leading-tight text-white/60`}>{option.note}</span></span>
        </button>;
      })}
    </div>
    <p className={`${large?'mt-3 text-[10px]':'mt-1.5 text-[9px]'} leading-relaxed text-white/60`}>Il contenuto resta identico: cambia soltanto la veste grafica.</p>
  </div>;
}
